import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { formatNaira } from '@/lib/utils';
import { Check, X, CircleNotch } from '@phosphor-icons/react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function PaymentCallbackPage() {
  const [params] = useSearchParams();
  const reference = params.get('reference') || params.get('trxref');
  const [status, setStatus] = useState('verifying');
  const [amount, setAmount] = useState(0);

  useEffect(() => {
    if (reference) {
      axios.get(`${API}/payments/verify/${reference}`)
        .then(({ data }) => {
          setStatus(data.status === 'success' ? 'success' : 'failed');
          setAmount(data.amount || 0);
        })
        .catch(() => setStatus('failed'));
    } else { setStatus('failed'); }
  }, [reference]);

  return (
    <div className="min-h-screen bg-[#E8DDD2] flex items-center justify-center p-6" data-testid="payment-callback-page">
      <div className="bg-white rounded-2xl border border-[#D4C5B3] p-8 max-w-[420px] w-full text-center shadow-sm">
        {status === 'verifying' && (
          <>
            <CircleNotch size={48} className="text-[#E86A33] mx-auto mb-4 animate-spin" />
            <h2 className="font-heading text-xl font-bold text-[#1C1C1C] mb-2">Confirming Payment...</h2>
            <p className="text-sm text-[#5C5C5C] font-body">Please wait while we verify your payment.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="w-20 h-20 bg-[#2D6A4F]/10 border-2 border-[#2D6A4F] rounded-full flex items-center justify-center mx-auto mb-4">
              <Check size={36} weight="bold" className="text-[#2D6A4F]" />
            </div>
            <h2 className="font-heading text-2xl font-bold text-[#1C1C1C] mb-2">Payment Confirmed!</h2>
            <p className="text-sm text-[#5C5C5C] font-body mb-2">Amount: {formatNaira(amount)}</p>
            <p className="text-xs text-[#5C5C5C] font-mono bg-[#E8DDD2] px-3 py-2 rounded-lg inline-block mb-6">Ref: {reference}</p>
            <div className="space-y-3">
              <Link to="/my-jobs" className="block w-full bg-[#1A4D2E] text-white font-bold py-3 rounded-xl font-body" data-testid="payment-view-jobs">View My Jobs</Link>
              <Link to="/" className="block w-full bg-[#E8DDD2] text-[#5C5C5C] font-bold py-3 rounded-xl font-body">Back to Home</Link>
            </div>
          </>
        )}
        {status === 'failed' && (
          <>
            <div className="w-20 h-20 bg-red-50 border-2 border-red-300 rounded-full flex items-center justify-center mx-auto mb-4">
              <X size={36} weight="bold" className="text-red-500" />
            </div>
            <h2 className="font-heading text-2xl font-bold text-[#1C1C1C] mb-2">Payment Failed</h2>
            <p className="text-sm text-[#5C5C5C] font-body mb-6">Something went wrong. Please try again.</p>
            <Link to="/my-jobs" className="block w-full bg-[#E86A33] text-white font-bold py-3 rounded-xl font-body">Go to My Jobs</Link>
          </>
        )}
      </div>
    </div>
  );
}
